/** API route map: URLS.Controller.EmployeeStatus */
export const EmployeeStatus = {
      Name: 'EmployeeStatus/',
      GetStatus: 'get-employee-status',
      AddEmployeeStatus: 'add-Employee-status',
      UpdateEmployeeStatus: 'update-Employee-status',
      DeleteEmployeeStatus: 'delete-Employee-status',
      UpdateEmployeeStatusList: 'update-Employee-status-list',
};
